@if (dataContext && form) {
  <section class="brf-pre-transfer">
    <form class="brf-pre-transfer__form astral-content-width astral-stack-l" [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
      <div class="header brf-pre-transfer__header">
        <h1>{{ 'COOPERATIVE_HOUSING.TRANSFER' | translate }}</h1>
      </div>

      <section class="astral-section-surface astral-stack-m">
        <h4>
          {{ 'COOPERATIVE_HOUSING.PRE_TRANSFER_EXISTING_CONTRACT' | translate }}
          ({{ form.controls['laterLeaseAgreementNumber'].value }})
        </h4>

        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
          <astral-toggle [control]="form.controls['isFirstTransfer']"></astral-toggle>
          <astral-select [control]="form.controls['laterTransferType']" [itemsSource]="transferTypes"></astral-select>
          @if (showLaterBuyAmount) {
            <app-money-box [control]="form.controls['laterPurchaseAmount']"></app-money-box>
          }
        </astral-layout-group>

        <div class="astral-stack-m">
          <h5>{{ 'COOPERATIVE_HOUSING.OWNER' | translate }}</h5>
          @for (buyerForm of $any(buyers.controls); track buyerForm; let i = $index) {
            <section class="astral-section-surface astral-section-surface--compact astral-section-surface--subtle">
              <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
                <astral-input class="astral-grid-span-2" [control]="buyerForm.controls['name']"></astral-input>
                <astral-input [control]="buyerForm.controls['share']" [type]="'number'" [inputMode]="'decimal'"></astral-input>
              </astral-layout-group>
            </section>
          }
        </div>
      </section>

      @if (showSellers) {
        <section class="astral-section-surface astral-stack-m">
          <h4>{{ 'COOPERATIVE_HOUSING.PRE_TRANSFER_SELLER_CONTRACT' | translate }}</h4>

          <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
            <astral-select [control]="form.controls['transferType']" [itemsSource]="transferTypes"></astral-select>
            @if (showBuyAmount) {
              <app-money-box [control]="form.controls['purchaseAmount']"></app-money-box>
            }
            <astral-date-picker [control]="form.controls['agreementDate']"></astral-date-picker>
            <astral-date-picker [control]="form.controls['fromDate']"></astral-date-picker>
            <astral-input [control]="form.controls['leaseAgreementNumber']"></astral-input>
          </astral-layout-group>

          <div class="astral-stack-m">
            <h5>{{ 'COOPERATIVE_HOUSING.OWNER' | translate }}</h5>
            @for (sellerForm of $any(sellers.controls); track sellerForm; let i = $index) {
              <section class="astral-section-surface astral-section-surface--compact astral-section-surface--subtle">
                <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
                  <div class="astral-grid-span-2">
                    <app-autocomplete-remote
                      [control]="sellerForm.controls['contactId']"
                      [service]="tenantService"
                      (itemSelected)="sellerSelected($event, i)"
                    ></app-autocomplete-remote>
                  </div>
                  <astral-input [control]="sellerForm.controls['share']" [type]="'number'" [inputMode]="'decimal'"></astral-input>
                  @if (sellers.length > 1) {
                    <div class="astral-delete-action astral-form-adjacent-action">
                      <astral-button
                        variant="secondary"
                        size="small"
                        type="button"
                        icon="trash"
                        labelKey="DELETE_BTN"
                        (click)="removeSeller(i)"
                      ></astral-button>
                    </div>
                  }
                </astral-layout-group>
              </section>
            }
          </div>

          <div>
            <astral-button variant="primary" size="small" type="button" icon="plus" labelKey="ADD_BTN" (click)="addSeller()"></astral-button>
          </div>
        </section>
      }

      <div class="brf-pre-transfer__actions">
        <astral-button variant="primary" type="submit" labelKey="SAVE_BTN"></astral-button>
        <astral-button variant="secondary" type="button" labelKey="CANCEL_BTN" (click)="cancel()"></astral-button>
      </div>
    </form>
  </section>
}
